<template>
  <div class="flex items-center bg-primary lg:min-h-[800px]">
    <div class="container py-20">
      <div class="mx-auto max-w-[480px]">
        <h1 class="text-white text-center uppercase mb-4">
          {{ pageData.title }}
        </h1>
        <div
          class="text-white ui-text-m text-center mb-8"
          v-html="pageData.description"
        />
        <AuthForgotEmailForm />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { $api } = useNuxtApp();
const { t } = useI18n();
const { visitEvent } = useEvents();

definePageMeta({
  middleware: ["guest"],
});

const { data } = await useAsyncCachedData("reset-password", () => {
  return $api.pages.getPage("reset-password", {
    skipErrors: [404, 500],
  });
});

const pageData = computed(() => {
  const currentTranslation = data.value?.data?.currentTranslation;
  return {
    title: currentTranslation?.title || t("resetYourPassword"),
    description:
      currentTranslation?.description || t("pleaseEnterYourEmailAddressBelow"),
  };
});

onMounted(() => {
  visitEvent();
});
</script>
